module.exports = __webpack_public_path__ + "static/member_02-c641b90f1110d0799d0b33638dae207d.jpg";